import React, { useCallback, useContext, useState,useEffect,useMemo, useReducer} from "react";
import { ModalNextContext,Card} from '@jutro/components';
import { Link } from '@jutro/router';
import { Flex, FlexItem,Grid, GridItem } from '@jutro/layout';

import { InputField, InputNumberField} from '@jutro/legacy/components';

import { ViewModelServiceContext,ViewModelForm,useDataRefresh } from '@xengage/gw-portals-viewmodel-react';
import { withRouter } from 'react-router-dom';
import { useTranslator, FormattedMessage,IntlContext } from '@jutro/locale';
import { messages as commonMessages } from '@xengage/gw-platform-translations';
import { LoaderExt } from 'gw-components-platform-react';
import { useAuthentication } from "@xengage/gw-digital-auth-react";
import _, { forEach, isArguments, random } from "lodash";
import moment from 'moment';
import  usecpmiAnalytics from "account-management/src/hooks/usecpmiAnalytics";
import useGoogleAnalytics from "account-management/src/hooks/useGoogleAnalytics";
import PayrollService from "cpmi-capability-payroll/services/PayrollService";
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import messages from "./CPMIStartPayrollCA.messages";
import metadata from "./CPMIStartPayrollCA.metadata.json5";
import styles from "./CPMIStartPayrollCA.module.scss";
import PayrollReviewCA from '../PayrollReviewCA/PayrollReviewCA';
// import CPMIClassCodeComponent from "./CPMIClassCodeComponent/CPMIClassCodeComponent";
// import CPMIClassCodeComponentGL from "./CPMIClassCodeComponentGL/CPMIClassCodeComponent";

function CPMIStartPayrollCA(props) {
    const ModalNext=useContext(ModalNextContext);
    const viewModelService = useContext(ViewModelServiceContext);
    const translator = useTranslator();
    const intl = useContext(IntlContext);
    const { authHeader } = useAuthentication();
    const [payrollVM,setPayrollVM] = useState([])
    const[trackPageView,trackEvent] = usecpmiAnalytics();
    const[trackGAPageView] = useGoogleAnalytics();
    const [payrollData,setPayrollData]=useState({})
    const [isLoading, setIsLoading] = useState(false)
    const [draftmsg,setdraftmsg]=useState(false)
    const [warningmsg,setwarningmsg]=useState(false);
    const [reviewData,setreviewData]=useState([])
    const [viewStartPage,setviewStartPage]=useState(true)
    const [stateData,setstateData]=useState([])
    const [totalData,settotalData]=useState({
        empCount:0,
        grossAmount:0
    })
    const [randomNumber,setrandomNumber]=useState(0);
    const [blankValues,setblankValues]=useState(false)
    const [refresh,setRefresh]=useState(null)
    const [PremptionError,setShowPremptionError]=useState(false)
    const [ignored, forceUpdate] = useReducer((x) => x + 1, 0);
    const {
        history,
        location:{
            state,
            state:{appValue}
        }
    }=props
    const [startPayrollButtonClicked,setstartPayrollButtonClicked] = useState(props.history.location.state.page)
    const { refreshData } = useDataRefresh();
    const [disabledNext,setdisabledNext]=useState(false)
    const [payrollButtonCLickedFlag, setPayrollButtonCLickedFlag]=useState(props?.history?.location?.state?.payrollFlag);
    

    

    //New variable
    const [premisesOperationExposure,setPremisesOperationExposure] =useState(null);
    const [productsCompletedOperationsExposure,setProductsCompletedOperationsExposure] =useState(null);
    

    useEffect(() => {
        trackPageView("start payroll","/startpayrollCA")
    },[])

    useEffect(() => {
        trackGAPageView("/startpayrollCA","Start/Edit Payroll")
    },[])

    useEffect(()=>{},[randomNumber])

    const CheckforPremption = useCallback((res)=>{
        // if(res.hasPreemptions){
        //     setShowPremptionError(true)
        // }
        // else{
        //     setShowPremptionError(false)
        // }
    },[])

    const setFinalpayrollData=useCallback((payroll)=>{
        
    },[])

    const getFormatAmt = (value) => {
        // value=value.toFixed(2)
        if(!isNaN(value) && value !== 0 && value !== "0"){
            var val = Math.round(Number(value) * 100) / 100;

            var parts = val.toFixed(2).split(".");
    
            var num = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",") + (parts[1] ? "." + parts[1] : "");
            
            return num
        }

        return 0;
        
    }

    const getInProgressReportPeriod=useCallback(()=>{
        if(appValue==="PE"){
            PayrollService.PEgetInProgressReportPeriod(state.jobNumber,authHeader).then((res)=>{
                
                if (Object.keys(res).length !== 0) {
                // res?.ca7PayrollDetails?.map((stateLoopItem,index)=>{
                    res?.ca7PayrollDetails?.ca7SystemGroups?.map((subLimeLoopItem,indexSubLime)=>{
                        // subLimeLoopItem?.gl7PayrollLocation?.map((locationLoopItem,indexLocation)=>{
                            if(payrollButtonCLickedFlag === "Start Payroll"){
                                // eslint-disable-next-line no-param-reassign
                                subLimeLoopItem.auditedExposure_Ext = ""
                                setdisabledNext(true);
                                
                            }else{
                                subLimeLoopItem.auditedExposure_Ext = subLimeLoopItem.auditedExposure_Ext === 0 ? "0" : subLimeLoopItem.auditedExposure_Ext
                               
                                if(subLimeLoopItem.auditedExposure_Ext === undefined) {
                                    setdisabledNext(true);
                                }
                            }
                        // })

                    })
                      
                // })
                res.exposureTotal = 0

                // eslint-disable-next-line array-callback-return
                res?.ca7PayrollDetails?.ca7SystemGroups.map((caLoopItem)=>{
                    if(caLoopItem.auditedExposure_Ext !== undefined){
                        res.exposureTotal +=parseInt(caLoopItem.auditedExposure_Ext) 
                    }                    
                })
                
                setPayrollData(res);
                CheckforPremption(res);
                setFinalpayrollData(res)
            }
            }).finally(()=>{setIsLoading(false)})
        }
        else{
            PayrollService.getInProgressReportPeriod(state.jobNumber,authHeader).then((res)=>{

                if (Object.keys(res).length !== 0) {
            // res?.ca7PayrollDetails?.map((stateLoopItem,index)=>{
                res?.ca7PayrollDetails?.ca7SystemGroups?.map((subLimeLoopItem,indexSubLime)=>{
                    // subLimeLoopItem?.gl7PayrollLocation?.map((locationLoopItem,indexLocation)=>{
                        if(payrollButtonCLickedFlag === "Start Payroll"){
                            // eslint-disable-next-line no-param-reassign
                            subLimeLoopItem.auditedExposure_Ext = ""
                            setdisabledNext(true);
                        }else{
                            subLimeLoopItem.auditedExposure_Ext = subLimeLoopItem.auditedExposure_Ext === 0 ? "0" : subLimeLoopItem.auditedExposure_Ext
                            
                            if(subLimeLoopItem.auditedExposure_Ext === undefined) {
                                setdisabledNext(true);
                            }
                        }
                    // })

                })
                  
            // })


                res.exposureTotal = 0

                // eslint-disable-next-line array-callback-return
                res?.ca7PayrollDetails?.ca7SystemGroups.map((caLoopItem)=>{
                    if(caLoopItem.auditedExposure_Ext !== undefined){
                        res.exposureTotal +=parseInt(caLoopItem.auditedExposure_Ext)
                    }                    
                })
                // setPayrollData(payrollData);
                setPayrollData(res);
                CheckforPremption(res);
                setFinalpayrollData(res)

                

                // setFormattedPayrollData(res);
                // CheckforPremption(res);
                // setFinalpayrollData(res)
            }
            }).finally(()=>{setIsLoading(false)})
            // PayrollService.getInProgressReportPeriod(state.jobNumber,authHeader).then((res)=>{setPayrollData(res);}).finally(()=>{setIsLoading(false)})
            
          
        }
        
    },[CheckforPremption, appValue, authHeader, payrollButtonCLickedFlag, setFinalpayrollData, state.jobNumber])

    useEffect(()=>{
        setIsLoading(true)
        getInProgressReportPeriod();
        
        //  setFormattedPayrollData(payrollData);
        //       setFinalpayrollData(payrollData);
    },[getInProgressReportPeriod, refresh])

    

    // useEffect(()=>{

    // },[stateEmployeeTotal,stateGrossPayTotal,longshoreAndHarborEmployeeTotal,longshoreAndHarborEmployeeTotal,admiraltyLawEmployeeTotal,admiraltyLawGrossPayTotal,FELAEmployeeTotal,FELAGrossPayTotal])


    

    const setFormattedPayrollData=useCallback((payroll)=>{

       
        // const  result = payroll.coveredEmployees.reduce((r, a) => {
        //     r[a.location.address.state] = r[a.location.address.state] || [];
        //     r[a.location.address.state].push(a);
        //     return r;
        // }, Object.create(null));
        // const tempStates=[];
        // for (const [key, value] of Object.entries(result)) {
        //     tempStates.push({
        //         stateCode:key,
        //         coveredEmployees:value
        //     })
        // }
        // payroll.states=tempStates;
        // setPayrollData(payroll);
    },[])

    

    const getStates=useCallback((statecode)=>{
       
        // if(statecode!==undefined && statecode!==' ' && viewModelService!==undefined){
        //     const typeList = viewModelService.create(
        //         {},
        //         'pc',
        //         'edge.capabilities.address.dto.AddressDTO'
        //     );
        //     const availableStates = typeList.state.aspects.availableValues
        //     const statename = availableStates.filter((s)=>{return s.code===statecode})
        //         .map((s)=>{return s.name})
        //     const res = translator({
        //         id:statename[0],
        //         defaultMessage:statename[0]
        //     })
        //     return  res; 
        // }
        // return ' '
    },[translator, viewModelService])

    const setUpdatedPayrollData=useCallback((id,updatedCoveredEmployees)=>{
        // id = id.split(/(\d+)/)
        
        
        // _.set(payrollData,`states[${id[1]}].coveredEmployees`,updatedCoveredEmployees)
        // setPayrollData(payrollData)
        // setFinalpayrollData(payrollData)

        // payrollData.states.forEach((states)=>{
        //     states.coveredEmployees.forEach((emp)=>{
        //         if(emp.auditedPayrollAmount>payrollData.totalEstimatedPayrollThreshold){
        //             setwarningmsg(true)
        //             return null;
        //         }
        //         setwarningmsg(false)
                    
        //     })
        // })
        // setblankValues(false)
        // setrandomNumber(Math.random()*10)

        // payrollData.ca7PayrollDetails.forEach((states)=>{
            // eslint-disable-next-line consistent-return
            payrollData.ca7PayrollDetails?.ca7SystemGroups?.forEach((emp)=>{
                
                // emp.gl7PayrollLocation.forEach((glclocatin)=>{
                    if(emp.auditedExposure_Ext>payrollData.totalEstimatedPayrollThreshold){
                        setwarningmsg(true)
                        
                        return null;
                    }
    
                    setwarningmsg(false)
                // })
                
                    
            })
        // })
        

    },[payrollData])

    

    const getPayrollData=useCallback(()=>{
        // if(appValue==='PE'){
        //     const states = payrollData.states
        //     return states
        // }
        // return payrollData.states;
        
        
    },[])

    const handleRefresh = useCallback(()=>{
        setRefresh(Math.random()*10)
    },[])

    const handleChangetoZero = useCallback(()=>{
        // setblankValues(true)
        if(Object.keys(payrollData).length !== 0){
            // eslint-disable-next-line array-callback-return
            payrollData?.ca7PayrollDetails?.ca7SystemGroups?.map((loopItem)=>{ 
                 if(loopItem.auditedExposure_Ext  === "" || loopItem.auditedExposure_Ext === undefined){
                    // eslint-disable-next-line no-param-reassign
                    loopItem.auditedExposure_Ext = "0"
                 }
            })
            setdisabledNext(false);
        }

        refreshData();
        // setrandomNumber(Math.random()*10)
    },[payrollData, refreshData])

   
    
    const exposureValueChange = useCallback((enteredValue,itemIndex)=>{
        // _.set(payrollData,Itempath, enteredValue);
        const arrayExposureValue = [];
        // eslint-disable-next-line array-callback-return
        payrollData?.ca7PayrollDetails?.ca7SystemGroups?.map((loopItem,indexPayroll)=>{
            if(indexPayroll ===itemIndex){
                // eslint-disable-next-line no-param-reassign
                loopItem.auditedExposure_Ext = enteredValue
                if(loopItem.auditedExposure_Ext > payrollData.totalEstimatedPayrollThreshold){
                    setwarningmsg(true);
                }else{
                    setwarningmsg(false);
                }
                
            }
           
            if(loopItem.auditedExposure_Ext ===""){
                arrayExposureValue.push(loopItem);
            }
        })
        if(arrayExposureValue.length  === 0){
            setdisabledNext(false);
        }else{
            setdisabledNext(true);
        }

        setPayrollData(payrollData);
        payrollData.exposureTotal = 0;
        // eslint-disable-next-line array-callback-return
        payrollData?.ca7PayrollDetails?.ca7SystemGroups.map((caLoopItem)=>{
            payrollData.exposureTotal +=parseInt(caLoopItem.auditedExposure_Ext) || 0
        })
        setPayrollData(payrollData);
        
        refreshData();
        
    },[payrollData, refreshData])

    
   
    // console.log(payrollData);
    // eslint-disable-next-line consistent-return
    const renderMainTable = useCallback(()=>{
        
        if(Object.keys(payrollData).length !== 0){
            // console.log(payrollData) 

        //    return payrollData?.ca7PayrollDetails?.ca7SystemGroups.map((caLoopItem)=>{
            return (<div >
            <Flex>
            <FlexItem>
                      <Card
                          id="Sdsds"
                          isPanel
                          subTitle=""
                          title=""
                          className={styles.cardClassWidthCA}

                      >
                          <div className={styles.cardBodyCalssCA}>
                    <div>Group</div>
                    <div>Group Description</div>
                    <div>Liability Deductible</div>
                    <div>Collision Deductible</div>
                    <div>Comprehensive Deductible</div>
                    <div># of Vehicles Issued</div>                    
                    <div>Exposure</div>
                </div>
                
                {
                // eslint-disable-next-line arrow-body-style
                payrollData?.ca7PayrollDetails?.ca7SystemGroups.map((caLoopItem,indexPath)=>{
                //    const finalPath = `payrollData.ca7PayrollDetails.ca7SystemGroups[${indexPath}].exposureValue` 
               return <div className={styles.cardBodyCalssMain}>
                    <div>{caLoopItem.group_Ext}</div>
                    <div>{caLoopItem.groupDescription_Ext}</div>
                    <div>{caLoopItem.liabilityDeductible}</div>
                    <div>{caLoopItem.collisionDeductible}</div>
                    <div>{caLoopItem.comprehensiveDeductible}</div>
                    <div>{caLoopItem.numOfVehicleIssued}</div>                    
                        <div className={styles.commonClassGridInputBox}>
                        <InputNumberField
                                    // path={finalPath}
                                     id="hjj"
                                     type="field"
                                     decimalPlaces={0}
                                     onValueChange={(value) => exposureValueChange(value,indexPath)}
                                     hideLabel
                                     value={caLoopItem.auditedExposure_Ext}
                                     className={styles.alignTextBoxNumber} />
                   
                   </div>
                </div>
                })
                
                }
                <div style={{paddingTop:'25px',paddingBottom:'34px'}}>
                    <hr />
                </div>

                <div className={styles.payrollPeriodTotalClass}>
                            <div style={{ 'textAlign': "right", marginRight: '80px', fontSize: '1rem', fontWeight: 'bold' }}>Payroll Period Total</div>
                            <div style={{ 'textAlign': "right", marginRight: '8px', fontSize: '1rem', fontWeight: 'bold',paddingRight:'10px', backgroundColor: '#78787878', border: '1px solid #78787878' }}>$ {getFormatAmt(payrollData?.exposureTotal) || 0}</div>
                        </div>
                      </Card>
                  </FlexItem>
              </Flex>
        </div>
            )
        
        }
    },[exposureValueChange, payrollData])

    const getsaveDraftMsg = useCallback(() =>{
        if(appValue==="PE"){
            return <>Your information has been saved! Please click<button className={styles.draftmsg} onClick={()=>{history.go(-1)}}>back</button>to go to previous screen</>
        }
        return <>Your information has been saved! Please click <Link to='/payroll-reporting/list/report'>back</Link> to go to previous screen</>
    },[appValue, history, props.location.pathname])

    const updateAuditReport=useCallback(async()=>{
        
        if(appValue==="PE"){
            await PayrollService.PEupdateAuditReport(payrollData,authHeader)
                .then(()=>{
                    setdraftmsg(true);
                })
                .catch(()=>{
                    ModalNext.showAlert({
                        //title: messages.draftErrorMessage,
                        title: (
                            <p className={styles.draftMsg}>
                                {translator(messages.draftErrorMessageGL)}
                            </p>
                        ),
                        status: 'error',
                        icon: 'mi-error-outline',
                        confirmButtonText: commonMessages.close
                    }).catch(_.noop);
                })
        }
        else{
            await PayrollService.updateAuditReport(payrollData,authHeader)
                .then(()=>{
                    setdraftmsg(true);
                })
                .catch(()=>{
                    ModalNext.showAlert({
                        
                        title: (
                            <p className={styles.draftMsg}>
                                {translator(messages.draftErrorMessageGL)}
                            </p>
                        ),
                        status: 'error',
                        icon: 'mi-error-outline',
                        confirmButtonText: commonMessages.close
                    }).catch(_.noop);
                })
        }
    },[ModalNext, appValue, authHeader, payrollData, translator])

    const handleCancel = useCallback(() => {
        ModalNext.showConfirm({
            title: messages.startpagecancelChangeTitleGL,
            message: messages.startpagecancelChangeMessageGL,
            status: 'info',
            icon: 'mi-error-outline',
            confirmButtonText: commonMessages.yesModel,
            cancelButtonText: commonMessages.noModel
        }).then((results) => {
            if(results === 'confirm'){
                history.go(-1)
            }
        }, _.noop);
    },[ModalNext, appValue, history, props.location.pathname])

    const getreportingperioddata=useCallback(()=>{
        if(!_.isEmpty(payrollData)){
            const startDate=moment(payrollData.reportPeriodStart).format('MM/DD/YYYY')
            const endDate=moment(payrollData.reportPeriodEnd).format('MM/DD/YYYY')

            return `${startDate} - ${endDate}`
        }
        return " "
    },[payrollData])


    const handleReview =useCallback(async()=>{
        // setIsLoading(true)
        
        // payrollData?.coveredEmployees?.map((item)=>{
        //     if(item?.auditedEmployeeCount===undefined){
        //         item.auditedEmployeeCount=0;
        //     }
        // })
        if(appValue==="PE"){
           
            await PayrollService.PEcalculatePremiumsForReport(payrollData,authHeader).then((result)=>{  
                // setPayrollData(result);
                setreviewData(result);
                setviewStartPage(false);
                setIsLoading(false);
            })
        }
        else{

            await PayrollService.calculatePremiumsForReport(payrollData,authHeader).then((result)=>{
                setIsLoading(false)
                return history.push({
                    pathname: `/payroll-reporting/reviewCA`,
                    state: {
                        data: result,
                        appValue:'CE'
                        
                      
                    },
                });
            })

            // await PayrollService.calculatePremiumsForReport(payrollData,authHeader).then((result)=>{
            //     setPayrollData(result);
            //     setreviewData(result)
            //     setviewStartPage(false)
            // })

        }
    },[appValue, authHeader, history, payrollData])

    // const renderClassNameForClassCode=useCallback(()=>{
    //     let classNameV = '';
    //     if(appValue ==='CE'){
    //         // eslint-disable-next-line no-const-assign
    //         classNameV = "CEclassCodeClClass"
    //     } 
    //     return classNameV;
    // },[appValue])

    const handlepremitionCancelBtn=useCallback(()=>{
        ModalNext.showConfirm({
            title:"Cancel payroll reporting update",
            message:"Are you sure you want to cancel your payroll reporting changes?",
            status: 'info',
            icon: 'mi-error-outline',
            confirmButtonText: commonMessages.yesModel,
            cancelButtonText: commonMessages.noModel,
        }).then((results) => {
            if (results === 'confirm') {
                history.go(-1);
            }
        }, _.noop);
    },[ModalNext, history])


    const generateOverrides = useMemo(() => {

       
        
    }, []);
    
    const DraftDataFromReview=useCallback((res)=>{
        // setPayrollData(res)
    },[])

    const overrides = {
        premptionCard:{
            visible:PremptionError
        },
        pageContainer:{
            visible:viewStartPage && !PremptionError
        },
        payrollDetails:{
            data:getPayrollData(),
        },
        reportingperioddata:{
            value:getreportingperioddata()
        },
        totalempcountdata:{
            value:totalData.empCount || `0`,
            // visible:totalData.empCount !==0
        },
        totalgrossamountdata:{
            value:totalData.grossAmount || `0`,
            // visible:totalData.grossAmount !==0
        },
        // totalempcount:{
        //     visible:(totalData.empCount !==0 || totalData.grossAmount !==0)
        // },
        savedraftmsg:{
            content:getsaveDraftMsg(),
            visible:draftmsg
        },
        savedraftmsg2:{
            content:getsaveDraftMsg(),
            visible:draftmsg
        },
        thersholdwaring:{
            visible:payrollData.exposureTotal>payrollData.totalEstimatedPayrollThreshold,
        },
        review:{
            disabled:!stateData.every((i)=>Object.values(i).every((value)=>value>=0))|| disabledNext
        },

        bodyClassCodeTable:{
            content: renderMainTable()
        },

        allStateTotals:{
            content:''//renderAllStateTotals()
        },
        
        // finaltotalStateAct:{
        //     visible:stateEmployeeTotal !==0 && stateGrossPayTotal !==0
        // },
        // longshoreAndHarborBlock:{
        //     visible:longshoreAndHarborEmployeeTotal !==0 && longshoreAndHarborGrossPayTotal !==0
        // },
        // admiraltyLawBlock:{
        //     visible:admiraltyLawEmployeeTotal !==0 && admiraltyLawGrossPayTotal !==0
        // },
        // FELABlock:{
        //     visible:FELAEmployeeTotal !==0 && FELAGrossPayTotal !==0
        // },
        payrollreviewCA:{
            data: reviewData,
            appValue:appValue,
            visible:!viewStartPage && !_.isEmpty(reviewData)&& !PremptionError,
            onCallback:setviewStartPage,
            DraftDataFromReview:DraftDataFromReview
        },
        ...generateOverrides,
        // ...juridictionOverrides
    };

    
    const resolvers = {
        resolveClassNameMap: styles,
        resolveCallbackMap: {
            handleCancel:handleCancel,
            handleRefresh:handleRefresh,
            handleDraft:updateAuditReport,
            handleReview:handleReview,
            setUpdatedPayrollData:setUpdatedPayrollData,
            handleChangetoZero:handleChangetoZero,
            handlepremitionCancelBtn:handlepremitionCancelBtn
        },
        resolveComponentMap:{
            // classCodeComponent:(props?.lineOfBusinessDesc === "General Liability (v7)" || props?.lineOfBusinessCode === "GL7GeneralLiability")?CPMIClassCodeComponentGL:CPMIClassCodeComponent,
            // classCodeComponent:CPMIClassCodeComponent,
            PayrollReviewCA
        }
    };

    if (isLoading) {
        return <LoaderExt loaded={!isLoading} />;
    }

    return  <ViewModelForm
        uiProps={metadata.pageContent}
        model={payrollData}
        overrideProps={overrides}
        componentMap={resolvers.resolveComponentMap}
        classNameMap={resolvers.resolveClassNameMap}
        callbackMap={resolvers.resolveCallbackMap}
    />
}

CPMIStartPayrollCA.defaultProps = {};
export default withRouter(CPMIStartPayrollCA);